import { render, staticRenderFns } from "./VuesticWidget.vue?vue&type=template&id=40708bde"
import script from "./VuesticWidget.vue?vue&type=script&lang=js"
export * from "./VuesticWidget.vue?vue&type=script&lang=js"
import style0 from "./VuesticWidget.vue?vue&type=style&index=0&id=40708bde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget.vue
// module id = TVMa
// module chunks = 41